import { DateTime, Duration } from "luxon";
import { IProject } from "src/app/admin/projects/shared/models/IProject";

export enum TimerStatus {
  Stopped,
  Active,
  Paused,
  New,
}

export interface Timer {
  projectId: number;
  project?: IProject;
  created: DateTime;
  start: DateTime;
  status: TimerStatus;
  minutesTimed: number;
  elapsedTimeDisplay?: string;
}
export interface TimerResponse {
  forProjectId: number;
  created: string;
  status: TimerStatus;
  start: string;
  minutesTimed: number;
}
